var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10003_16745)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22221 2C4.33807 2 2 4.33808 2 7.22226C2 10.1064 4.33807 12.4445 7.22221 12.4445C8.62352 12.4445 9.89593 11.8926 10.8339 10.9942C10.8572 10.9649 10.8825 10.9366 10.9096 10.9095C10.9367 10.8824 10.9649 10.8572 10.9942 10.8339C11.8925 9.89592 12.4444 8.62354 12.4444 7.22226C12.4444 4.33808 10.1064 2 7.22221 2ZM12.9873 11.5731C13.902 10.363 14.4444 8.856 14.4444 7.22226C14.4444 3.23352 11.2109 0 7.22221 0C3.23349 0 0 3.23352 0 7.22226C0 11.211 3.23349 14.4445 7.22221 14.4445C8.856 14.4445 10.3631 13.902 11.5731 12.9873L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L12.9873 11.5731Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10003_16745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d9a142010e52a1afea984e1b85f348c6.svg";
export { ForwardRef as ReactComponent };